@if (operateur) {
  <div class="row p-3">
    <div class="col-12">
      <div class="cards border-radius text-center">
        <div class="row">
          <div class="col-lg-4 text-center">
            <div class=" border-radius pt-2 text-center">
              <img src="/assets/img/user.svg" width="50%" alt="user"/><br />
              <strong style="font-size:22px">{{operateur.prenom}} {{operateur.nom | uppercase}}</strong><br />
              <a (click)="goToDetail()">
                <fa-icon icon="map-marked-alt" class="mt-2 p-2" style="font-size:20px"></fa-icon>
                  <strong>{{nbSites}}Site(s)</strong>
                <fa-icon icon="chevron-right" class="ms-2"></fa-icon>
              </a>
            </div>
          </div>
          <div class="col-lg-4 text-end pt-2">
            <ul class="list-group list-group-flush text-start border-radius" style="font-size:13px">
              <li class="list-group-item ms-4 me-4">
                <small class="w-25">Statut juridique</small>
                <strong>{{operateur.structureJuridique}}</strong>
              </li>
              <li class="list-group-item ms-4 me-4">
                <small class="w-25">Raison sociale</small>
                <strong>{{operateur.raisonSociale}}</strong>
              </li>
              <li class="list-group-item ms-4 me-4">
                <small class="w-25">N° SIRET</small>
                <strong>{{operateur.siret}}</strong>
              </li>
              <li class="list-group-item ms-4 me-4">
                <small class="w-25">N° CVI</small>
                <strong>{{ nbCVI?.valeur || '-' }}</strong>
              </li>
              <li class="list-group-item ms-4 me-4">
                <small class="w-25">Adresse</small>
                <strong>{{operateur.adresse}} {{operateur.codePostal}} {{operateur.ville}}</strong>
              </li>
              <li class="list-group-item ms-4 me-4">
                <small class="w-25">Tel / Port</small>
                @if (operateur.telephoneFixe) {
                  <strong>{{operateur.telephoneFixe | phoneFormat}}</strong>
                }
                <strong> / </strong>
                @if (operateur.telephoneMobile) {
                  <strong>{{operateur.telephoneMobile | phoneFormat}}</strong>
                }
              </li>
              <li class="list-group-item ms-4 me-4">
                <small class="w-25">Email</small>
                <strong>{{operateur.email}}</strong>
              </li>
            </ul>
            <a (click)="goToDetail()"><strong>Détails </strong>
              <fa-icon icon="chevron-right" class="right"></fa-icon>
            </a>
          </div>
          <!-- Historique des modifications -->
          <div class="col-lg-4 pt-2 border-radius">
            <div class="d-flex align-items-center justify-content-center mt-2">
              <fa-icon icon="history" class="p-2"></fa-icon>
              <strong>Historique des modifications</strong>
            </div>
            @for (modification of modifications; track modification.idModification) {
              <div>
                <div class="w-auto text-start border-bottom">
                  @if (modification.typeModification === 'Majeure') {
                    <fa-icon icon="exclamation" class="p-2 red"></fa-icon>
                  }
                  <strong>{{ modification.dateModification | date:'dd/MM/yyyy' }} </strong>
                  <span>-</span>
                  <span> Modification {{ modification.informationModifiee }}</span>
                  @if (hasOrganisme(modification.idOrganisme)) {
                    <span> ({{ getOrganisme(modification.idOrganisme) }})</span>
                  }
                </div>
                <br/>
              </div>
            }
            @if (modifications.length === 0) {
              <span class="pl-4">Aucune modification réalisée.</span>
            }
            <div class="text-end pointer pe-1">
              <a (click)="goToDetailModifications()" class="cursor-pointer">
                <strong>Détails </strong>
                <fa-icon icon="chevron-right" class="right"></fa-icon>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row p-3">
    <div class="col-8">
      <div class="cards  border-radius p-4 pb-2 text-center">
        <fa-icon icon="file-contract" class="mt-2 p-2" style="font-size:20px"></fa-icon><strong> Télédéclarations</strong>
        <div class="row">
          <div class="col-lg-4">
            <div class=" border-radius p-2" (click)="goToSynthese()" (keydown.enter)="goToSynthese()" style="cursor: pointer;">
              <div class=" badge-light  badge-light-blue">
                <fa-icon icon="pen"></fa-icon>
              </div>
              <p><small style="display:block;">Saisir mes déclarations</small></p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class=" border-radius p-2" (click)="goToImport()" (keydown.enter)="goToImport()" style="cursor: pointer;">
              <div class=" badge-light  badge-light-blue">
                <fa-icon icon="file-alt"></fa-icon>
              </div>
              <p><small style="display:block;">Données ProDouanes</small></p>
            </div>
          </div>
          <div class="col-4">
            <div class=" border-radius p-2" (click)="goToHistorique()" (keydown.enter)="goToHistorique()" style="cursor: pointer;">
              <div class=" badge-light  badge-light-blue">
                <fa-icon icon="folder-open"></fa-icon>
              </div>
              <p><small style="display:block;">Historique</small></p>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="col-4">
      <div class="cards  border-radius  p-4 pb-2 text-center">
        <fa-icon icon="clipboard-check" class="mt-2 p-2" style="font-size:20px"></fa-icon><strong> Contrôles</strong>
        <div class="row">



          <div class="col-lg-6">
            <div class=" border-radius p-2">
              <div class=" badge-light  badge-light-vert">
                -
              </div>
              <p><small style="display:block;">contrôle(s) produit en cours</small></p>
            </div>
          </div>

          <div class="col-lg-6">
            <div class=" border-radius p-2">
              <div class=" badge-light  badge-light-red">
                {{nbManquements}}
              </div>
              <p><small style="display:block;">manquement(s)</small></p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  @if (!estOperateur && urlFacturationPanel) {
      <div class="row p-3">
          <div class="col-lg-2">
            <div class="cards  border-radius  p-4  text-start cursor" (click)= "goToFactures()" (keydown.enter)="goToFactures()">
              <fa-icon icon="euro-sign"  class="p-2" style="font-size:20px"></fa-icon><strong> Factures</strong>
              <div class="row">
              </div>
            </div>
          </div>
      </div>
    }
} @else {
  <div class="row mt-4 pt-4 ps-5">
    <div class="col-12">
      <div class="cards border-radius p-4 text-center" style="background:#f8faff">
        @if (loadingOperateur) {
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Chargement...</span>
          </div>
        }
        @if (!loadingOperateur && operateurLoadingError) {
          <div class="alert alert-danger m-0">
            Impossible de charger les informations de l'opérateur.
          </div>
        }
      </div>
    </div>
  </div>
}
